<template>
    <div class="tx-toast">
        {{ text }}
    </div>
</template>
<script setup>
import { onMounted } from 'vue';
const props = defineProps({
    text: {
        type: String,
        required: true
    },
    duration: {
        type: Number,
        default: 1,
        required: true
    },
    id: {
        type: String,
        required: true
    }
})

const emit = defineEmits(['close'])
onMounted(() => {
    setTimeout(() => {
        emit('close', props.id)
    }, props.duration*1000)
})
</script>